import React from 'react'
import ClientListContainer from './ClientListContainer'

export default function ClientListScreen() {
    return <ClientListContainer />
}
